// /frontend/src/pages/dashboard/post/previews/ThreadsPreview.js
import React from 'react';

export default function ThreadsPreview({ caption, files }) {
  const main = files.length ? files[0].url : null;
  const isImage = main && /\.(jpe?g|png|gif)$/i.test(main);

  return (
    <div className="border rounded" style={{ maxWidth: 380, margin: '0 auto' }}>
      <div className="p-2 fw-bold">threads_user</div>
      {caption && <p className="px-2" style={{ whiteSpace: 'pre-wrap' }}>{caption}</p>}
      {main && (
        isImage ? (
          <img src={main} alt="" style={{ width: '100%', objectFit: 'cover' }} />
        ) : (
          <video src={main} controls style={{ width: '100%' }} />
        )
      )}
    </div>
  );
}
